import React, { Fragment, useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { Btn, H5, Spinner } from "../../../AbstractElements";
import { useDispatch, useSelector } from "react-redux";
import { Col } from "reactstrap";
import { fetchDietCharts } from "../../../Redux/stateSlice/dietChartReducer";
import AddModal from "./AddModal";

const DataTableComponent = () => {
  const [viewModal, setViewModal] = useState(false);
  const dispatch = useDispatch();
  const { loading, dietCharts, error, pagination } = useSelector(
    (state) => state.dietCharts
  );
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedRows, setSelectedRows] = useState([]);

  const toggleModal = () => setViewModal((prev) => !prev);

  useEffect(() => {
    dispatch(fetchDietCharts(currentPage, 10));
  }, [dispatch, currentPage]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleRowSelected = (state) => {
    setSelectedRows(state.selectedRows);
  };

  if (loading) {
    return (
      <Col className="vh-100 d-flex align-items-center justify-content-center">
        <div className="loader-box">
          <Spinner attrSpinner={{ className: "loader-5" }} />
        </div>
      </Col>
    );
  }

  if (error) {
    return <p>Error: {error}</p>;
  }

  const tableColumns = [
    // { name: "Id", selector: (row) => row._id, sortable: true, center: true },
    { name: "Name", selector: (row) => row.name, sortable: true, center: true },
    { name: "Serving Size", selector: (row) => row.servingSize, sortable: true, maxWidth: "120px" },
    { name: "Protein", selector: (row) => row.protein, sortable: true, maxWidth: "100px" },
    { name: "Fat", selector: (row) => row.fat, sortable: true, maxWidth: "100px" },
    { name: "Carbs", selector: (row) => row.carbs, sortable: true, maxWidth: "100px" },
    { name: "Calories", selector: (row) => row.calories, sortable: true, maxWidth: "100px" },
    { name: "Ideal Time", selector: (row) => row.idealTime, sortable: true },
    { name: "Suitable For", selector: (row) => row.suitableFor, sortable: true, maxWidth: "150px" }
  ];

  return (
    <Fragment>
      <div className="d-flex align-items-center justify-content-between p-2">
        <H5 attrH5={{ className: "text-muted m-0" }}>Diet Chart</H5>
        <Btn attrBtn={{ color: "primary", onClick: toggleModal }}>Add Diet Chart</Btn>
      </div>

      <DataTable
        data={dietCharts}
        columns={tableColumns}
        striped
        center
        pagination
        paginationServer
        paginationTotalRows={pagination?.total || 0}
        onChangePage={handlePageChange}
        paginationDefaultPage={currentPage}
        selectableRows
        onSelectedRowsChange={handleRowSelected}
      />

      <AddModal viewModal={viewModal} modalToggle={toggleModal} />
    </Fragment>
  );
};

export default DataTableComponent;
